// GN: calculadora de frete (regra por prefixo de CEP, igual à Entrega local do admin).

// Bloqueio de compra (classes no <html>, aplicadas já no <head> a partir do localStorage):
// - gn-frete-fora: CEP salvo fora da área → "Adicionar ao carrinho" e "Finalizar compra" desativados.
// - gn-frete-sem-cep: nenhum CEP calculado ainda → só "Finalizar compra"/"Compre já" pedem o CEP antes.
if (!window.gnFreteBloqueio) {
  window.gnFreteBloqueio = (() => {
    const STATUS = 'gn-frete-status';
    const ADICIONAR = 'button[name="add"]';
    const FINALIZAR = '[name="checkout"], #checkout, .shopify-payment-button__button';
    const raiz = document.documentElement;

    const aplicar = (status) => {
      raiz.classList.toggle('gn-frete-fora', status === 'fora');
      raiz.classList.toggle('gn-frete-sem-cep', !status);
    };

    const definir = (status) => {
      try {
        if (status) localStorage.setItem(STATUS, status);
        else localStorage.removeItem(STATUS);
      } catch (e) {}
      aplicar(status);
      // Avisa a página (faixa do CEP, janela de entrada — assets/gn-conversao.js).
      document.dispatchEvent(new CustomEvent('gn:frete', { detail: { status } }));
    };

    let aviso;
    const mostrarAviso = (texto) => {
      if (!aviso) {
        aviso = document.createElement('div');
        aviso.className = 'gn-frete-aviso';
        aviso.setAttribute('role', 'alert');
        document.body.appendChild(aviso);
      }
      aviso.textContent = texto;
      aviso.classList.add('gn-frete-aviso--visivel');
      clearTimeout(aviso.timer);
      aviso.timer = setTimeout(() => aviso.classList.remove('gn-frete-aviso--visivel'), 5000);
    };

    // Leva o cliente até a calculadora; sem calculadora na página (ex.: aviso de "item adicionado"), vai ao carrinho.
    const irParaCalculadora = (texto) => {
      const calculadora = document.querySelector('gn-frete');
      mostrarAviso(texto);
      if (calculadora) {
        calculadora.scrollIntoView({ behavior: 'smooth', block: 'center' });
        calculadora.querySelector('input')?.focus({ preventScroll: true });
      } else {
        setTimeout(() => (window.location.href = (window.Shopify?.routes?.root || '/') + 'cart'), 1200);
      }
    };

    const fora = () => raiz.classList.contains('gn-frete-fora');
    const semCep = () => raiz.classList.contains('gn-frete-sem-cep');
    const MSG_FORA = 'Ainda não entregamos no CEP informado. Altere o CEP para continuar a compra.';
    const MSG_CEP = 'Informe seu CEP para finalizar a compra.';

    const barrar = (e, texto) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      irParaCalculadora(texto);
    };

    // Fase de captura: roda antes dos handlers do Dawn (product-form, cart, cart-notification).
    document.addEventListener(
      'click',
      (e) => {
        const alvo = e.target.closest?.(`${ADICIONAR}, ${FINALIZAR}`);
        if (!alvo) return;
        if (fora()) return barrar(e, MSG_FORA);
        if (semCep() && alvo.matches(FINALIZAR)) barrar(e, MSG_CEP);
      },
      true
    );
    document.addEventListener(
      'submit',
      (e) => {
        const adicionar = (e.target.action || '').includes('/cart/add');
        const finalizar = e.submitter?.name === 'checkout';
        if (fora() && (adicionar || finalizar)) return barrar(e, MSG_FORA);
        if (semCep() && finalizar) barrar(e, MSG_CEP);
      },
      true
    );

    // Mantém outras abas sincronizadas.
    window.addEventListener('storage', (e) => {
      if (e.key === STATUS) aplicar(e.newValue);
    });

    return { definir };
  })();
}

// Botão "Comprar no Mercado Livre" (snippets/gn-mercadolivre.liquid): na página do produto o link acompanha o peso.
if (!customElements.get('gn-ml')) {
  customElements.define(
    'gn-ml',
    class GnMl extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('.gn-ml__links');
        if (!json || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        let links = {};
        try {
          links = JSON.parse(json.textContent);
        } catch (e) {
          return;
        }
        this.cancelar = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (this.dataset.section && data.sectionId !== this.dataset.section) return;
          const a = this.querySelector('.gn-ml__botao');
          if (a && data.variant) a.href = links[data.variant.id] || this.dataset.padrao;
        });
      }

      disconnectedCallback() {
        this.cancelar?.();
      }
    }
  );
}

if (!customElements.get('gn-frete')) {
  customElements.define(
    'gn-frete',
    class GnFrete extends HTMLElement {
      static CHAVE = 'gn-frete-cep';

      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="cep"]');
        this.resultado = this.querySelector('.gn-frete__resultado');
        this.prefixos = (this.dataset.prefixos || '').split(',').map((p) => p.trim()).filter(Boolean);
        this.input.addEventListener('input', () => (this.input.value = this.mascara(this.input.value)));
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.calcular(true);
        });
        // Outra calculadora da página (ex.: janela de CEP na entrada) calculou um CEP: mostra o mesmo aqui.
        document.addEventListener('gn:frete-cep', (e) => {
          if (e.detail.fonte === this || this.input.value.replace(/\D/g, '') === e.detail.cep) return;
          this.input.value = this.mascara(e.detail.cep);
          this.calcular();
        });
        let salvo = null;
        try {
          salvo = localStorage.getItem(GnFrete.CHAVE);
        } catch (e) {}
        if (salvo) {
          this.input.value = this.mascara(salvo);
          this.calcular();
        }
      }

      mascara(valor) {
        const d = valor.replace(/\D/g, '').slice(0, 8);
        return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
      }

      mostrar(html, tipo) {
        this.resultado.hidden = false;
        this.resultado.className = `gn-frete__resultado gn-frete__resultado--${tipo}`;
        this.resultado.innerHTML = html;
      }

      // Bairro e cidade só para o cliente conferir o CEP. A resposta do frete NÃO espera por isto:
      // a regra é o prefixo do CEP, e o ViaCEP às vezes leva vários segundos (ou não responde).
      // Devolve null se o CEP não existe; {} se o ViaCEP falhou.
      async endereco(cep) {
        const controle = new AbortController();
        const prazo = setTimeout(() => controle.abort(), 2500);
        try {
          const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { signal: controle.signal });
          const d = await r.json();
          if (d.erro) return null;
          return { bairro: d.bairro || '', cidade: d.localidade || '', uf: d.uf || '' };
        } catch (e) {
          return {};
        } finally {
          clearTimeout(prazo);
        }
      }

      // Métrica: consulta de CEP feita pelo cliente (não a recalculada ao abrir a página), com o canal de
      // origem. Vai para o GA4 pelo pixel personalizado "GN - CEP no GA4" (Configurações > Eventos de clientes).
      // Só os 5 primeiros dígitos do CEP; o mesmo CEP conta uma vez por sessão.
      registrar(cep, atendido, local) {
        const enviados = (() => {
          try {
            return JSON.parse(sessionStorage.getItem('gn-cep-enviados') || '[]');
          } catch (e) {
            return [];
          }
        })();
        if (enviados.includes(cep)) return;
        try {
          sessionStorage.setItem('gn-cep-enviados', JSON.stringify([...enviados, cep]));
        } catch (e) {}
        const origem = window.gnOrigem?.atual() || {};
        window.Shopify?.analytics?.publish?.('gn_cep_consultado', {
          atendido: atendido ? 'sim' : 'nao',
          cep_prefixo: cep.slice(0, 5),
          cidade: local.cidade || '(desconhecida)',
          uf: local.uf || '',
          canal: origem.canal || 'Direto',
          fonte: origem.fonte || '',
          midia: origem.midia || '',
          campanha: origem.campanha || '',
          pagina: location.pathname,
        });
      }

      async calcular(digitado = false) {
        const cep = this.input.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          this.mostrar('Digite um CEP válido com 8 números.', 'erro');
          return;
        }
        const consulta = (this.consulta = (this.consulta || 0) + 1);
        try {
          localStorage.setItem(GnFrete.CHAVE, cep);
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('gn:frete-cep', { detail: { cep, fonte: this } }));
        const onde = '<span class="gn-frete__local" hidden></span>';
        const atendido = this.prefixos.some((p) => cep.startsWith(p));
        if (atendido) {
          window.gnFreteBloqueio.definir('ok');
          this.mostrar(
            `<strong class="gn-frete__preco"><svg class="gn-icone gn-icone--raio" viewBox="0 0 24 24" aria-hidden="true"><path d="M14.2 1.5 4.6 13.4h6.1l-1.6 9.1 9.7-12.2h-6.2l1.6-8.8z" fill="currentColor"/></svg>${this.dataset.preco}</strong>
             <span class="gn-frete__prazo">${this.dataset.prazo}</span>${onde}`,
            'ok'
          );
        } else {
          window.gnFreteBloqueio.definir('fora');
          this.mostrar(
            `<strong>Ainda não entregamos neste CEP.</strong>
             <span>Atendemos ${this.dataset.area}. Para o seu CEP, compre em nossa loja oficial no Mercado Livre.</span>${onde}`,
            'fora'
          );
        }

        // Depois, sem travar a resposta: completa com o bairro, ou avisa se o CEP não existe.
        const local = await this.endereco(cep);
        if (consulta !== this.consulta) return; // um CEP mais novo já foi calculado
        if (local === null) {
          window.gnFreteBloqueio.definir(null);
          try {
            localStorage.removeItem(GnFrete.CHAVE);
          } catch (e) {}
          this.mostrar('CEP não encontrado. Confira os números e tente de novo.', 'erro');
          return;
        }
        if (digitado) this.registrar(cep, atendido, local);
        const texto = [local.bairro, local.cidade && `${local.cidade}/${local.uf}`].filter(Boolean).join(', ');
        const span = this.resultado.querySelector('.gn-frete__local');
        if (span && texto) {
          span.textContent = texto;
          span.hidden = false;
        }
      }
    }
  );
}

// GN: sacola no botão "Compre já" (botão da Shopify, renderizado depois do carregamento).
(() => {
  const ICONE =
    '<svg class="gn-icone" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 7h14l-1.2 13H6.2L5 7z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/><path d="M9 10V6a3 3 0 0 1 6 0v4" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>';
  const aplicar = () =>
    document.querySelectorAll('.shopify-payment-button__button--unbranded:not([data-gn-icone])').forEach((botao) => {
      botao.dataset.gnIcone = '1';
      botao.insertAdjacentHTML('afterbegin', ICONE);
    });
  const iniciar = () => {
    aplicar();
    new MutationObserver(aplicar).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
